import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toggleIframeActionDialog } from '../../store/actions/session';
import { WithBackBtHandeling } from './WithBackHandling';

export const IFrameBareDialog: React.FC<{
    id?: string;
    url: string;
    closeMe: () => void;
    contentWrapperCSS?: string;
    style?: { [k: string]: string };
}> = ({ id, url, closeMe, contentWrapperCSS, style }) => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            exit={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2, ease: 'linear' }}
            className="font-lato absolute inset-0"
            style={{ zIndex: 1000 }}
        >
            <div onClick={closeMe} className="modal-overlay" />

            <div
                className={`flex flex-col modal-content w-50p h-5/6 ${contentWrapperCSS || ''}`}
                style={style}
            >
                <iframe
                    id={id}
                    referrerPolicy="strict-origin"
                    className="w-full h-full rounded-t-8"
                    src={url}
                />

                <div className="flex items-center p-16 border-t border-neutral-7 justify-end bg-white rounded-b-8">
                    <div>
                        <button
                            onClick={closeMe}
                            className="primary-btn px-12 py-8 btn--small fill"
                        >
                            <span className="w-full text-center">Close</span>
                        </button>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

const IFrameDialog: React.FC<{ id?: string; url: string }> = ({ id, url }) => {
    const dispatch = useDispatch();

    const closeMe = () => {
        dispatch(toggleIframeActionDialog());
    };

    useEffect(() => {
        if (!url) {
            closeMe();
        }
    }, [url]);

    return (
        <WithBackBtHandeling close={closeMe} whoAmI="iframe">
            <IFrameBareDialog id={id} url={url} closeMe={closeMe} />
        </WithBackBtHandeling>
    );
};

export default IFrameDialog;
